import React from "react";

/**
 * The diagonal-stripe placeholder shown where an image has not been uploaded.
 *
 * It stands for nothing — there is no image yet, and announcing "image" for a
 * hole where one might later go is a lie a screen reader cannot see through.
 * Hence `aria-hidden` AND `role="presentation"`. All sizing comes from
 * `className`; this component owns only the stripes and the corner radius.
 *
 * @param {Object} props
 * @param {string} [props.className] - Sizing and layout classes from the caller.
 */
export const Hatch = ({ className = "" }) => (
  <div
    aria-hidden="true"
    role="presentation"
    className={`bg-bc-hatch rounded-md ${className}`}
  />
);
